import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const FooterContainer = styled.footer`
  background-color: #f5f7f9;
  padding: 20px 0;
  text-align: center;
  border-top: 1px solid #e7e7e7;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 0 20px;
`;

const FooterSection = styled.div`
  margin: 20px;
  min-width: 200px;
  text-align: left;
`;

const FooterTitle = styled.h3`
  color: #14464F;
  margin-bottom: 15px;
  font-size: 18px;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FooterLink = styled(Link)`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: #14464F;
  }
`;

const ExternalLink = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  &:hover {
    color: #14464F;
  }
`;

const Footer = () => {
  const { language } = useLanguage();
  
  const content = {
    en: {
      contact: 'Contact',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      rights: 'All rights reserved.',
    },
    es: {
      contact: 'Contacto',
      terms: 'Términos y Condiciones',
      privacy: 'Política de Privacidad',
      cookies: 'Política de Cookies',
      rights: 'Todos los derechos reservados.',
    },
  };

  const t = content[language];
  const year = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Quisqueya Quest</FooterTitle>
          <FooterLinks>
            <ExternalLink href="mailto:contact@quisqueyaquest.com">{t.contact}</ExternalLink>
          </FooterLinks>
        </FooterSection>
        <FooterSection>
          <FooterTitle>Legal</FooterTitle>
          <FooterLinks>
            <FooterLink to="/legal/terms">{t.terms}</FooterLink>
            <FooterLink to="/legal/privacy">{t.privacy}</FooterLink>
            <FooterLink to="/legal/cookies">{t.cookies}</FooterLink>
          </FooterLinks>
        </FooterSection>
      </FooterContent>
      <div
        style={{
          marginTop: 8,
          padding: '16px 20px 20px',
          borderTop: '1px solid #e7e7e7',
          textAlign: 'center',
          color: '#888',
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        © {year} Quisqueya Quest. {t.rights}
      </div>
    </FooterContainer>
  );
};

export default Footer;
